import { useColumns } from '../columns/createUpdateColumns';

/**
 * Returns parameters for creating or updating a mail sender record based on the type.
 *
 * @hook
 * @param {Object} params - The parameters for setting create/update parameters.
 * @param {string} params.type - The type of mail sender record.
 * @param {string} params.sendingType - The type of sending (e.g., 'EMAIL', 'POST').
 * @param {Object} params.enums - The enums object.
 * @returns {Object} - Returns an object with parameters.
 */
export const useMailSenderListParameters = ({ type, sendingType, enums }) => {
  const { pensionerColumns, ownerColumns, veterinarianAndGroomerColumns } =
    useColumns({ enums, type });

  switch (type) {
    // Every pensioner who asked for the bulletins, as the automatic mailing
    // does: is_in_supervision is not kept up to date and hid some of them.
    case 'ANOUNCEMENT':
      return {
        resourceName: 'pensioners',
        resourceModelName: 'Pensioner',
        columns: pensionerColumns,
        extraQuery:
          sendingType === 'POST'
            ? `internet_access=${false}&is_newsletters=${true}`
            : `internet_access=${true}&is_newsletters=${true}`
      };
    case 'PENSIONER_WISH':
    case 'OTHER_PENSIONER':
      return {
        resourceName: 'pensioners',
        resourceModelName: 'Pensioner',
        columns: pensionerColumns,
        extraQuery:
          sendingType === 'POST'
            ? `internet_access=${false}`
            : `internet_access=${true}`
      };
    case 'OWNER_WISH':
    case 'OWNER_EXPLANATORY_DOCUMENT':
    case 'OTHER_OWNER':
      return {
        resourceName: 'owners',
        resourceModelName: 'Owner',
        columns: ownerColumns,
        extraQuery:
          sendingType === 'POST'
            ? `internet_access=${false}`
            : `internet_access=${true}`
      };
    case 'PENSIONER_EXPLANATORY_DOCUMENT':
      return {
        resourceName: 'pensioners',
        resourceModelName: 'Pensioner',
        columns: ownerColumns,
        extraQuery:
          sendingType === 'POST'
            ? `internet_access=${false}`
            : `internet_access=${true}`
      };
    case 'VETERINARIAN_ADVERT':
      return {
        resourceName: 'veterinarians',
        resourceModelName: 'Veterinarian',
        columns: veterinarianAndGroomerColumns
      };
    case 'GROOMER_ADVERT':
      return {
        resourceName: 'groomers',
        resourceModelName: 'Groomer',
        columns: veterinarianAndGroomerColumns
      };
    // Type d'envoi inconnu (donnée héritée) : la page affiche un message
    // plutôt que de planter.
    default:
      return {
        unsupported: true,
        resourceName: null,
        resourceModelName: null,
        columns: [],
        populate: null,
        extraQuery: null
      };
  }
};
